<template>
  <v-card dark>
    <v-btn large absolute right top icon @click="$emit('close')">
      <v-icon>mdi-close</v-icon>
    </v-btn>
    <v-row class="justify-content-center ma-0">
      <v-col cols="auto">
        <lottie-player
          mode="normal"
          style="height: 100px; width: 120px"
          name="roody_icon"
          autoplay
          src="/img/lottiefiles/roody_animated.json"></lottie-player>
      </v-col>
    </v-row>
    <v-card-title class="text-center" style="word-break: break-word"> Jetzt auch im App- und Playstore </v-card-title>
    <v-row class="justify-content-center ma-0">
      <v-col cols="auto">
        <a title="Play Store Link" target="__blank" href="https://play.google.com/store/apps/details?id=ch.wellcomefit.roody&gl=US&pli=1">
          <v-img class="text-center" width="150" height="50" src="/img/einmalig/googlePlayBadge.png"></v-img>
        </a>
      </v-col>
      <v-col cols="6">
        <a target="__blank" title="App Store Link" href="https://apps.apple.com/de/app/roody/id1641472611">
          <v-img contain class="text-center" width="150" height="50" src="/img/einmalig/appstoreBadge.svg"></v-img>
        </a>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
export default {
  // This component is purely presentational and only needs to emit a close event.
}
</script>
